<script setup>
  import { useNoteTypeStore } from "@/stores/useNoteTypeStore";
  import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";
  
  const emit = defineEmits(["close"]);
  const noteTypeStore = useNoteTypeStore();
  
  // ===============================
  // ✅ Tratamento de erro específico
  // ===============================
  function buildNoteTypeDeleteError(error) {
    const raw =
      error?.response?.data?.message ||
      error?.message ||
      "";
  
    // mensagem default que você já usa
    let userFriendlyMessage =
      "Não é possível excluir essa CATEGORIA DE NOTA porque existe SUBTIPO DE NOTA vinculada a ela.";
  
    // se vier algo do backend, preserva (sem engolir mensagem útil)
    if (raw) userFriendlyMessage = raw;
  
    // reforço amigável quando claramente é FK (sem depender 100% de string exata)
    const looksLikeFK =
      raw.includes("foreign key constraint fails") ||
      raw.toLowerCase().includes("constraint") ||
      raw.toLowerCase().includes("foreign key");
  
    if (looksLikeFK) {
      userFriendlyMessage =
        "Esta categoria de nota está vinculada a um ou mais Subtipos de Nota e não pode ser removida.\nPara excluí-la, remova primeiro todos os subtipos associados a esta categoria de nota.";
    }
  
    return userFriendlyMessage;
  }
  
  // ===========================================
  // ✅ onConfirm: executa e deixa o modal cuidar
  // ===========================================
  async function onConfirmDelete() {
    try {
      await noteTypeStore.deleteNoteTypeById(noteTypeStore.idNoteType);
  
      // mantém exatamente seu comportamento atual
      noteTypeStore.shouldForcePageOne = true;
    } catch (error) {
      const msg = buildNoteTypeDeleteError(error);
      throw new Error(msg);
    }
  }
  </script>
  
  <template>
    <DeleteConfirmModal
      :show="true"
      title="Apagar Categoria de Nota"
      messageTitle="Tem certeza que deseja excluir esta categoria de nota?"
      messageSubtitle="Esta ação não pode ser desfeita."
      confirmText="Sim, excluir"
      cancelText="Cancelar"
      loadingText="Apagando..."
      :onConfirm="onConfirmDelete"
      @close="emit('close')"
    />
  </template>
  